import React from 'react';
import { Typography, Box } from '@mui/material';
import { Assignment as MarksEntryIcon } from '@mui/icons-material';
import { RiCalendarScheduleLine } from 'react-icons/ri';
import { TbReportSearch } from 'react-icons/tb';
import { MdOutlineSubject } from 'react-icons/md';
import { AiTwotoneEdit } from 'react-icons/ai';
import { PiGraduationCapFill } from 'react-icons/pi';

import ReusableTabs from '../UIElements/ReusableTabs';
import MarksEntryTab from './MarksEntryTab';
import MarksReportTab from './MarksReportTab';
import Subjects from './Subjects';
import ExaminationTypes from './ExaminationTypes';
import ExamSchedule from './Schedule/ExamSchedule';
import GradeConfiguration from './Grades/GradeConfiguration';

const StudentMarksManagement = () => {
  // Tabs configuration
  const marksTabs = [
    {
      label: 'Marks Entry',
      icon: <MarksEntryIcon />,
      content: <MarksEntryTab />,
    },
    {
      label: 'Reports',
      icon: <TbReportSearch className='size-5' />,
      content: <MarksReportTab />,
    },
    {
      label: 'Subjects',
      icon: <MdOutlineSubject className='size-5' />,
      content: <Subjects />,
    },
    {
      label: 'Examinations',
      icon: <AiTwotoneEdit className='size-5' />,
      content: <ExaminationTypes />,
    },
    {
      label: 'Schedule',
      icon: <RiCalendarScheduleLine className='size-5' />,
      content: <ExamSchedule />,
    },
    {
      label: 'Grades',
      icon: <PiGraduationCapFill className='size-5' />,
      content: <GradeConfiguration />,
    },
  ];

  const handleTabChange = (tabIndex, tabData) => {
    console.log('Active marks tab:', tabData.label);
  };

  return (
    <Box className='p-4'>
      {/* Header */}
      <Box className='bg-blue-50 p-4 rounded-lg'>
        <Typography variant='h6' className='text-blue-700 font-bold'>
          Student Marks Management System
        </Typography>
        <Typography variant='body1' className='text-gray-600'>
          Comprehensive academic performance tracking and analysis
        </Typography>
      </Box>
      <ReusableTabs
        tabs={marksTabs}
        variant='scrollable'
        onChange={handleTabChange}
        allowScrollButtons={true}
        className='w-full'
      />
    </Box>
  );
};

export default StudentMarksManagement;
